"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  component: {
    workPermitTips: '(Tips: please upload the final approved work permit)',
    fileInfo: 'Attachment',
    uploadFile: 'Upload File',
    fileUpload: 'File Upload',
    sqlUpload: 'SQL Upload',
    more: 'MORE',
    no: 'No',
    syncFlag: 'Vessel Shore Synch',
    fileName: 'Attachment',
    contentFlag: 'Abstract ',
    uploadTime: 'Time',
    uploadDept: 'Department',
    uploader: 'Operator',
    option: 'Operation',
    fileUploadType: 'File Upload Business Type',
    vesselSync: 'Vessel Shore Sync',
    file: 'File',
    sqlFile: 'SQL',
    preTip: 'Hold down the Ctrl key to upload multiple files, up to',
    sufTip: 'files at a time;Only *** files and no more than 10M can be uploaded',
    editTip: 'Only *** files and no more than 3M can be uploaded',
    plsChooseBusinessType: 'Please select business type',
    plsChooseFile: 'Please select file',
    fileNoHt3MB: 'The attachment size cannot exceed 3MB!',
    fileNoHt10MB: 'The attachment size cannot exceed 10MB!',
    uploadNumCheck1: 'Only ',
    uploadNumCheck2: 'file can be selected to upload at the same time at a time. You have selected ',
    uploadNumCheck3: 'document this time, please adjust and try again'
  },
  workflow: {
    companyName: 'Company Name',
    process: 'Business Process Management',
    option: 'Operation',
    currentApprover: 'Current Approver',
    currentDept: 'Current Dept',
    handlingOpinions: 'Handling Opinions',
    commonOpinions: 'Common Opinions',
    remark: 'Personal Notes',
    remarkTip: '(This note is the current to-do note, only visible to you)',
    addRemark: 'Add Remark',
    pleInputOpinions: 'Please Input Opinions',
    pleInputRemark: 'No Remarks',
    remindVessel: 'Remind Vessel',
    approvalHistory: 'Approval History',
    approvalProcess: 'Approval Process',
    approvalDate: 'Approval Date',
    approver: 'Approver',
    approvalDept: 'Approval Dept',
    certigier: 'Certigier',
    approvalOption: 'Approval Option',
    approvalOpinion: 'Approval Opinion',
    forSelect: 'forSelect',
    selected: 'Selected',
    seqNo: 'Seqno',
    userName: 'User Name',
    employeeNo: 'Employee No',
    name: 'Name',
    dept: 'Dept',
    turnTo: 'Turn To',
    transferRole: 'Transfer Role',
    transferUser: 'Transfer User',
    transferRemark: 'Transfer Remark',
    transferSuccess: 'Transfer Success',
    saveRemarkSuccess: 'Save Remark Success'
  },
  compliance: {
    complianceFile: 'Compliance Screening Accessories',
    complianceScreening: 'Compliance Screening/Sanctions Screening',
    integrityAudit: 'Integrity Audit',
    upload: 'Upload'
  },
  systemPractice: {
    systemDocuments: 'System Documents'
  }
};